
import React from 'react'
// hooks
import DefaultAvatar from '@mui/material/Avatar'
import usePfp from '../hooks/usePfp'
//
import Avatar, { Props as AvatarProps } from './Avatar'

// ----------------------------------------------------------------------

export default function MyPfp({ ...other }: AvatarProps) {
	const { id, tokens } = usePfp()

	const activePfp = tokens.find((token) => token.id === id)

	if (!activePfp) {
		return (
			<DefaultAvatar alt="My Pfp" />
		)
	}

	return (
		<Avatar
			src={activePfp.image}
			alt="My Pfp"
			color="default"
			{...other}
		/>
	)
}
